<template>
  <div
      class="side_menu"
      @mouseenter="clickSideMenu"
      @mouseleave="hideSideMenuInfo"
    >
      <div
        class="item_list"
        style="height: 292px"
        v-if="showKefu && showKefuIndex == 0"
        @mouseenter="mouseEnter(0)"
        @mouseleave="mouseLeave(0)"
      >
        <div
          class="list"
          :style="{ marginTop: 83 * Number(showKefuIndex) + 'px' }"
        >
          <div
            class="list_item"
            :style="index == 3 ? 'border-bottom:none' : ''"
            v-for="(item, index) in sideMenuInfo"
            :key="index"
            @click="index == 2 ? gotoNet(item.path) : gotokefu()"
          >
            <div class="item_title">{{ item.title }}</div>
            <div class="item_info">{{ item.info }}</div>
          </div>
        </div>
      </div>
      <div
        class="item_list"
        style="height: 292px"
        v-if="showKefu && showKefuIndex == 1"
        :style="{ marginTop: 83 * Number(showKefuIndex) + 'px' }"
        @mouseenter="mouseEnter(1)"
        @mouseleave="mouseLeave(1)"
      >
        <div class="list">
          <!-- <div class="list_item" style="border-bottom: none">
            <div
              class="item_title"
              style="font-size: 15px; margin-bottom: 5px"
            >
            商城热线
            </div>
            <div class="item_info" style="font-size: 12px">400-091-9520</div>
          </div> -->
          <div
            class="list_item"
            v-for="(item, index) in sideMenuInfo"
             :style="index == 3 ? 'border-bottom:none' : ''"
            :key="index"
          >
            <div class="item_title">{{ item.title }}</div>
            <div class="item_info">{{ item.info }}</div>
          </div>
          
        </div>
      </div>

      <div
        class="item_list"
        style="height: 310px; overflow-y: auto;overflow-x: hidden;"
        v-if="showKefu && showKefuIndex == 2 && couponData.length>0"
        :style="{ marginTop: 83 * Number(showKefuIndex) + 'px' }"
        @mouseenter="mouseEnter(2)"
        @mouseleave="mouseLeave(2)"
      >
      
        <div class="list">
          <div class="coupon_title ">
            <div class="title">优惠券</div>
            <!-- <div class="btn" @click="receive()">一键领取</div> -->
          </div>
          <div
            class="coupon_item"
            v-for="(item, index) in couponData"
            :key="index"
          >
            <img src="../assets/coupon_bg.png" alt="" />
            <!-- <img src="../assets/get_coupon.png" alt="" /> -->
            <div class="item_info">
              <div class="item_price">
                <div class="price"><span>￥</span>{{ item.publishValue }}</div>
                <div class="coupon">
                  <div class="coupon_name">{{ item.couponName }}</div>
                  <div class="coupon_content">{{ item.couponContent }}</div> 
                  
                  <!-- <div class="coupon_content">满{{ item.limitQuota }}元可用</div> -->
                </div>
              </div>

              <!-- <div class="coupon">优惠券</div> -->
               <div class="tb">
                <div class="info">
                  {{ item.effectiveStart.split(" ")[0].replace(/-/g, '.') }} -
                  {{ item.effectiveEnd.split(" ")[0] .replace(/-/g, '.') }}
                </div>
                <div class="receive_btn" @click="receive(item)">领取</div>
               </div>
              

            </div>
          </div>
        </div>
      </div>
      <div
        class="item_list"
        style="height: 128px"
        v-if="showKefu && showKefuIndex == 3 &&  !loginFlag"
        :style="{
          marginTop: showCoupon
            ? 83 * Number(showKefuIndex) + 'px'
            : 83 * (Number(showKefuIndex) - 1) + 'px',
        }"
        @mouseenter="mouseEnter(3)"
        @mouseleave="mouseLeave(3)"
      >
        <div class="list">
          <div class="gift_box">
            <div class="title">注册即享</div>
            <div class="title">888元大礼包</div>
            <div class="btn" @click="goToByPush('/login')">注册领取</div>
          </div>
        </div>
      </div>
      <div
        class="menu_box"
        :style="
          expand
            ? showCoupon
              ? 'height:332px'
              : 'height:249px'
            : 'height:83px'
        "
      >
        <div class="item" @mouseenter="showSideMenuInfo('0')" @click="gotokefu()">
          <img src="../assets/service/kefu.png" alt="" />
          <div>咨询客服</div>
        </div>
        <div v-if="expand">
          <div class="item" @mouseenter="showSideMenuInfo('1')">
            <img src="../assets/service/kefuphone.png" alt="" />
            <div>400热线</div>
          </div>
          <div
            class="item"
            @mouseenter="showSideMenuInfo('2')"
            v-if="showCoupon"
          >
            <img src="../assets/service/coupon.png" alt="" />
            <div>优惠券</div>
          </div>
          <div class="item" @mouseenter="showSideMenuInfo('3')">
            <img src="../assets/service/gift.png" alt="" />
            <div>新人礼</div>
          </div>
          <div class="expand_arrow" @click="changeExpand">
            <img
              src="../assets/expand_arrow.png"
              style="transform: rotate(180deg)"
              alt=""
            />
          </div>
        </div>

        <div v-else class="expand_arrow" @click="changeExpand">
          <img src="../assets/expand_arrow.png" alt="" />
        </div>
        <div class="top_box" style="margin-top: 30px" @click="goTop" v-if="showGotoTop">
          <div class="item">
            <img src="../assets/top.png" alt="" />
            <div>回到顶部</div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { getCurrentInstance, reactive, onMounted, ref,watch,computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from "vuex";
import { ElMessage } from 'element-plus';

export default {
  name: 'KefuSlip',
  components: {

  },
  props: {
    productId: {type: Number},
    showGotoTop:{type:Boolean,default:false},
    couponIData:{type:Array}
  },

  setup(props,{ emit }) {
      const router = useRouter()
      const { proxy } = getCurrentInstance()
      const L = proxy.$getCurLanguage()
      
      const showKefu = ref(false);
      const showKefuIndex = ref("");
      const sideMenuInfo = ref([]);
      const expand = ref(false);
      const clickSide = ref(false);
      const clickInfo = ref(false);
      const store = useStore();
      const couponData = ref(store.state.couponList);
      const showCoupon = ref(store.state.showCoupon);
      const memberInfo = ref(store.state.memberInfo);
      const loginFlag = computed(() => store.state.loginFlag);
      
      const goTop= ()=>{
        emit('goTop')
      }

      const clickSideMenu = () => {
        clickSide.value = true;
      };

      const hideSideMenuInfo = () => {
        clickSide.value = false;
        clickInfo.value = false;
        showKefu.value = false;
        expand.value = false;
      };

    const mouseEnter = (index) => {
      showKefuIndex.value = index;
    };
    const mouseLeave = (index) => {
      clickInfo.value = false;
      if (!clickSide.value) {
        setTimeout(() => {
          showKefu.value = false;
          expand.value = false;
          // clickSide.value = false
        }, 2000);
      } else {
      }
    };
    
    const gotokefu = () => {
      // const platform = 'ecstore';
      // const type = '1';
      // const isTourist = 0;
      // if (store.state.loginFlag) {
      //   var leftPosition = window.screen.width - 1200;
      //   let url = "https://dev-asus.njsyue.com/cs/web/app/index.html#/home-page?userId=" 
      //     + memberInfo.value.memberId + "&platform=" + platform + "&type=" + type 
      //     + "&isTourist=" + isTourist + "&from=pc";
      //   if (props.productId) {
      //     url += "&goodId=" + props.productId;
      //   }
      //   var windowFeatures = `width=1100,height=700,left=${leftPosition},top=100,scrollbars=no`; 
      //   window.open(url, '_blank',windowFeatures)
      // } else {
      //   router.push({  path: '/login',query:{} })
			// }

      proxy.$gotokefu(props);
    };

    const showSideMenuInfo = (index) => {
      console.log("you");
      expand.value = true;
      showKefuIndex.value = index;
      clickSide.value = true;
      switch (index) {
        case "0":
          sideMenuInfo.value = [
            {
              title: "售前咨询,获取更多优惠",
              info: "9:00~24:00",
            },
            {
              title: "订单售后，华硕商城购买",
              info: "9:00~24:00",
            },
            {
              title: "官网咨询技术",
              info: "9:00~22:00",
              path: "https://livechat.asus.com.cn/chat/#/gpt/5449957",
            },
            {
              title: "华硕小二，享全方位服务",
              info: "9:00~24:00",
            },
          ];
          break;
        case "1":
          sideMenuInfo.value = [
          {
              title: "商城热线",
              info: "400-091-9520",
            },
            {
              title: "笔记本服务热线",
              info: "400-600-6655",
            },
            {
              title: "ROG产品服务热线",
              info: "400-616-6655",
            },
            {
              title: "DIY产品服务热线",
              info: "400-620-6655",
            },
          ];
          break;
      }
      showKefu.value = true;
    };
    const changeExpand = () => {
      expand.value = !expand.value;
    };

    const getHomeDeCoupon = () => {
      let params = {
        couponIds:[]
      }
      let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };

      proxy.$post('v3/promotion/front/coupon/diyHomeCouponList', params,config).then(res => {
        if (res.state == 200) {
          ElMessage.success(res.msg)
          console.log('youhuiquan---------->',res.data)
        } else {
          ElMessage.error(res.msg)
        }
      })
    }
      //领取优惠卷
      const receive = (couponItem) => {

        if(store.state.loginFlag){
          let params = {
            couponId:couponItem.couponId
          }
          proxy
            .$get('v3/promotion/front/coupon/receiveCoupon',params)
            .then(res => {
              if (res.state == 200) {
                ElMessage.success(L['领取成功'])
              } else {
                // ElMessage.success(res.msg)
                ElMessage.error('您已领取过该优惠券')
              }
            })
            .catch(() => {
              //异常处理
            })
        }else{
          goToByPush('/login')
        }

            
        }

            //前往具体的页面，type为具体的页面地址，param为参数对象
    const goToByPush = (type, param = {}) => {

        // if (type == '/service') {
        // let chatInfo = {
        //   storeId: 0,
        //   vendorAvatar: configInfo.platform_customer_service_logo,
        //   storeName: configInfo.platform_customer_service_name,
        //   showData: {},
        //   source: 'pc商城'
        // }
        // store.commit('saveChatBaseInfo', chatInfo)

        // let newWin = router.resolve({
        //   path: type,
        //   query: param
        // })

        // window.open(newWin.href, '_blank')
        // return
        // }

        router.push({
        path: type,
        query: param
        });
        };

        const gotoNet = (url) =>{
          window.open(url, '_blank');
        }
    
    watch(
      () => props.couponIData,
      (newVal, oldVal) => {
        couponData.value = newVal; 
      },
      { deep: true } 
    );

    onMounted(() =>{
      // getHomeDeCoupon()
      //  console.log('couponList',couponList)
      // console.log('couponData',couponData)
    })
    return { L, 
      getHomeDeCoupon,receive,goToByPush,loginFlag,gotoNet,
      showKefu,clickSideMenu,hideSideMenuInfo, showKefuIndex,mouseEnter,mouseLeave,sideMenuInfo,gotokefu,showSideMenuInfo,
      showCoupon,couponData,expand,changeExpand,goTop,clickSide,clickInfo,memberInfo
    }
  },
}
</script>
<style lang="scss" scoped>

.side_menu {

  display: flex;

  .menu_box {
    position: relative;
    width: 80px;
    text-align: center;
    background: #ffffff;
    // box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
    cursor: pointer;
    box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #f2f2f2;
    .item {
      padding: 15px 0;
      height: 83px;
      z-index: 889;
      position: relative;

      img {
        width: 30px;
        height: 30px;
      }

      div {
        margin-top: 5px;
        font-family: Microsoft YaHei,Microsoft YaHei ;
        font-weight: 400;
        font-size: 12px;
        color: #7e91bc;
        line-height: 18px;
        text-align: center;
      }
    }
    .item:hover {
      background: rgba(175, 182, 194, 0.1);
    }
    .expand_arrow {
      position: absolute;
      bottom: -15px;
      left: 25px;
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 50%;
      // line-height: 30px;
      text-align: center;
      z-index: 888;

      img {
        margin-top: 5px;
        width: 20px;
        height: 20px;
      }
    }
    .top_box {
      box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #f2f2f2;
      background: #ffffff;
    }
  }

  .item_list {
    position: relative;
    background: #ffffff;
    margin-right: 5px;
    cursor: pointer;
    box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #f2f2f2;
    // text-align: center;
    .list {
      width: 185px;

      .list_item {
        padding: 14px 0 14px 10px;
        border-bottom: 1px solid rgba(175, 182, 194, 0.1);
        .item_title {
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
          margin-bottom: 5px;
        }

        .item_info {
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 12px;
          color: #7e91bc;
          line-height: 18px;
        }
      }
      .list_item:hover {
        background: rgba(175, 182, 194, 0.1);
      }
      .coupon_title {
        display: flex;
        padding: 16px 10px;
        justify-content: space-between;
        align-items: center;

        .title {
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
        }

        .btn {
          margin-left: 10px;
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 14px;
          text-align: center;
          background: #1e7cff;
          border-radius: 2px;
          padding: 5px 10px;
        }
      }

      .coupon_item {
        position: relative;

        img {
          position: relative;
          width: 175px;
          height: 76px;
          margin: 0 5px;
        }

        .item_info {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;
          // justify-content: center;
          align-items: center;

          .item_price {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px 12px;
            
            // margin-bottom: 4px;
            .price {
              font-family: Microsoft YaHei,Microsoft YaHei ;
              font-weight: 600;
              font-size: 25px;
              color: #DF443B;
              line-height: 30px;
              text-align: center;
              width: 88px;
              // margin-top: 5px;
              >span{
                font-weight: 600;
                font-size: 15px;
                color: #DF443B;
                line-height: 20px;
              }
            }

            .coupon {
              // padding-left: 13px;
              width: 87px;
              margin-left: auto;

              .coupon_name {
                width: 72px;
                font-family: Microsoft YaHei,Microsoft YaHei;
                font-weight: 400;
                font-size: 9px;
                color: #000000;
                line-height: 15px;
                overflow: hidden;
                text-overflow: ellipsis; //文本溢出显示省略号
                white-space: nowrap; //文本不会换行
              }

              .coupon_content {
                width: 72px;
                font-family: Microsoft YaHei,Microsoft YaHei;
                font-weight: 400;
                font-size: 9px;
                color: #888e98;
                line-height: 15px;
              }
            }
          }

          .tb{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 5px;
            .info {
              // width: 96px;
              // padding-top: 4px;
              // border-top: 1px dashed rgba(223,68,59,0.1);
              font-family: Microsoft YaHei,Microsoft YaHei;
              // font-weight: 400;
              // font-size: 9px;
              // color: #888e98;
              // line-height: 15px;
              // text-align: center;
              font-weight: 400;
              font-size: 9px;
              color: #888E98;
              line-height: 15px;
            }
            .receive_btn{
              width: 32px;
              height: 14px;
              background: rgba(223,68,59,0.1);
              border-radius: 2px 2px 2px 2px;
              border: 1px solid #DF443B;
              font-weight: 400;
              font-size: 9px;
              color: #DF443B;
              line-height: 13px;
              text-align: center;
              margin-left: 18px;

            }
          }
         
        }
      }

      .gift_box {
        height: 128px;
        background: #ffffff;
        // box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
        border-radius: 0px 0px 0px 0px;
        // border: 1px solid #f2f2f2;
        text-align: center;
        padding: 20px 0;

        .title {
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
        }

        .btn {
          text-align: center;
          margin: 20px auto;
          width: 68px;
          height: 24px;
          background: #1e7cff;
          border-radius: 2px 2px 2px 2px;
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 24px;
        }
      }
    }
  }
}
</style>